import React, { useState, useEffect } from "react";
import { Link, withRouter } from "react-router-dom";
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaRegUserCircle } from "react-icons/fa";
import { useSelector } from 'react-redux';



import "./styles.scss";

import Connect from "../../redux/Connect.hoc";
import { logout } from "../../redux/action/admin.actions";
import logo from "../../media/logo_combinado.jpg";
import user from "../../media/user.png";
import LoginComponent from "../../../components/public/Login/Login.component";
import SigninComponent from "../../../components/public/Signin/Signin.component";
import RecoverPassComponent from "../../../components/public/RecoverPass/RecoverPass.component";
import OptionsToolBar from "../OptionsToolBar/OptionsToolBar";
import Auth from "../authentication";

const ToolBar = ({ history }) => {
  //State Auth Redux
  const auth = useSelector((state) => state.auth.user)

  // Variables
  const sizeIcons = '2rem';
  //Metodos
  useEffect(() => {
    console.log(" --ToolBar.useEffect-- ", auth);
  }, []);
  
  //hooks
  const [visibleLogin, setVisibleLogin] = useState(false);
  const [visibleSignin, setVisibleSignin] = useState(false);
  const [visibleForget, setVisibleForget] = useState(false);

  const onClickLogin = () => {
    setVisibleLogin(state => !state);
  }

  const onClickSingIn = () => {
    setVisibleSignin(state => !state);
  }

  const onClickForget = () => {
    setVisibleForget(state => !state);
    onClickLogin();


  }

  // Childrens





  const Icons = () => {
    return (
      <>
        <div className='Div-logo'>
          <Link to="/">
            <img
              src={logo}
              alt='logo'
            />

          </Link>


        </div>
        <div className="Div-icons">

          <a
            className='spaceIconBar'
            href='http://facebook.com/'
          >
            <FaFacebookF
              fontSize={sizeIcons}
              color='#767676'
            />

          </a>

          <a
            className='spaceIconBar'
            href='http://instagram.com/'
          >
            <FaInstagram
              fontSize={sizeIcons}
              color='#767676'
            />

          </a>

          <a
            className='spaceIconBar'
            href='http://linkedin.com/'
          >
            <FaLinkedinIn
              fontSize={sizeIcons}
              color='#767676'
              style={{ position: "relative", right: "15px" }}
            />

          </a>
        </div>





      </>
    )



  }



  // Return
  return (
    <>
      <nav className="ToolBar-Nav">
        <ul class="ToolBar-Nav-ul">
          <Icons />
          <li class='ToolBar-Nav-li'>
            <div class='ToolBar-Nav-div'
              onClick={auth == null ? onClickLogin : null}


            >
              <a>
                < FaRegUserCircle
                  fontSize={sizeIcons}
                  color='#767676'
                />
                <p>{auth == null ?"Iniciar sesión" : auth.name}</p>
              </a>
              <OptionsToolBar
                state={auth}
                history={history}
              />

            </div>
          </li>
        </ul>

      </nav>
      <Auth
      onClickForget = {onClickForget}
      onClickLogin = {onClickLogin}
      onClickSingIn = {onClickSingIn}
      visibleForget= {visibleForget}
      visibleLogin = {visibleLogin}
      visibleSignin= {visibleSignin}
      />

    </>
  );
};
export default Connect(withRouter(ToolBar));
